import DashboardLayout from "../components/dashboard-layout";

const Support = () => {
    return (<>
                support
            </>)
}

export default Support